import React, {
    RefObject,
} from 'react'

import {
    inputIconWrapper,
    searchAutocompleItems, searchAutocompleteInput, searchAutocompleteInputWrapper, searchAutocompleteNoResults,
    searchAutocompleteResultsButton, searchAutocompleteResultsHeader, searchAutocompleteResultsWrapper, searchAutocompleteWrapper,
} from './styles/SearchAutocomplete.styles'

import {SearchAutocompleteItem} from './types'

import {styled} from 'stitches/config'
import {
    styledLabel,
} from 'components/Form/styles/FormView'
import {useTranslation} from 'react-i18next'

const StyledInput = styled('input', searchAutocompleteInput)
const StyledLabel = styled('label', styledLabel)
const StyledResultsWrapper = styled('div', searchAutocompleteResultsWrapper)
const StyledAutocompleteWrapper = styled('div', searchAutocompleteWrapper)
const StyledResultsItems = styled('div', searchAutocompleItems)
const StyledResultItem = styled('button', searchAutocompleteResultsButton)
const StyledResultsHeader = styled('div', searchAutocompleteResultsHeader)
const StyledNoResults = styled('div', searchAutocompleteNoResults)
const StyledSearchAutocompleteInputWrapper = styled('div', searchAutocompleteInputWrapper)
const StyledInputIcon = styled('div', inputIconWrapper)

interface SearchAutocompleteViewProps {
    label?: string;
    handleChangeSearchValue: (ev: React.ChangeEvent<HTMLInputElement>) => void,
    handleSelectItem: (item: SearchAutocompleteItem) => (ev: React.MouseEvent) => void,
    setAutocompleteOpen: () => void,
    autocompleteInputRef: RefObject<HTMLInputElement>,
    autocompleteResultsRef: RefObject<HTMLDivElement>,
    searchValue: string,
    autocompleteOpen: boolean,
    placeholder?: string,
    featuredActive: boolean,
    items: Array<SearchAutocompleteItem>,
    selectedItems: Array<SearchAutocompleteItem>,
    Template: React.FC<SearchAutocompleteItem>,
    CustomNoResults?: React.FC<{searchValue: string, handleSelectItem: (item: SearchAutocompleteItem) => (ev: React.MouseEvent) => void,}>,
    CustomResultsHeader?: React.FC,
    customNoResultsShowLogic?: (searchValue: string, items: Array<SearchAutocompleteItem>) => boolean;
    customResultsHeaderShowLogic?: (searchValue: string, items: Array<SearchAutocompleteItem>) => boolean;
    InputIcon?: React.FC;
    dropdownHeight?: number;
    tabIndex?: number;
}

const SearchAutocompleteView = (props: SearchAutocompleteViewProps) => {
    const {
        handleChangeSearchValue,
        handleSelectItem,
        setAutocompleteOpen,
        autocompleteInputRef,
        autocompleteResultsRef,
        searchValue,
        autocompleteOpen,
        label,
        placeholder,
        featuredActive,
        items,
        selectedItems,
        Template,
        CustomNoResults,
        CustomResultsHeader,
        customNoResultsShowLogic,
        customResultsHeaderShowLogic,
        InputIcon,
        dropdownHeight,
        tabIndex,
    } = props

    const {t} = useTranslation()

    const renderNoResults = () => {
        const showCustomNoResults = customNoResultsShowLogic ? customNoResultsShowLogic(searchValue, items) : false

        return items.length === 0 && (
            showCustomNoResults && !!CustomNoResults ?
                <CustomNoResults handleSelectItem={handleSelectItem} searchValue={searchValue} />
                :
                <StyledNoResults>{t('No results')}</StyledNoResults>
        )
    }

    const renderResultsHeader = () => {
        const showCustomResultsHeader = customResultsHeaderShowLogic ? customResultsHeaderShowLogic(searchValue, items) : false

        return (
            <StyledResultsHeader>
                {showCustomResultsHeader && !!CustomResultsHeader ?
                    <CustomResultsHeader /> :
                    featuredActive ? t('Suggestions') : t('Search results')}
            </StyledResultsHeader>
        )
    }

    return (
        <StyledAutocompleteWrapper>
            {!!label && <StyledLabel htmlFor='autocompleteInput'>{label}</StyledLabel>}
            <div>
                <StyledSearchAutocompleteInputWrapper >
                    {!!InputIcon && <StyledInputIcon><InputIcon /></StyledInputIcon>}
                    <StyledInput
                        autoComplete='off'
                        id='autocompleteInput'
                        isOpen={autocompleteOpen}
                        onChange={handleChangeSearchValue}
                        onFocus={setAutocompleteOpen}
                        placeholder={placeholder}
                        ref={autocompleteInputRef}
                        showIcon={!!InputIcon}
                        tabIndex={tabIndex}
                        value={searchValue}
                    />
                </StyledSearchAutocompleteInputWrapper>
                <StyledResultsWrapper hidden={!autocompleteOpen} ref={autocompleteResultsRef}>
                    <div style={{maxHeight: dropdownHeight}}>
                        {renderResultsHeader()}
                        <StyledResultsItems>
                            {items.map((item: SearchAutocompleteItem) => (
                                <StyledResultItem key={item.id} onClick={handleSelectItem(item)} {...(autocompleteOpen ? {tabIndex} : {})} type='button'>
                                    <Template {...item} selected={!!selectedItems.find((selectedItem) => selectedItem.id === item.id)} />
                                </StyledResultItem>
                            ))}
                            {renderNoResults()}
                        </StyledResultsItems>
                    </div>
                </StyledResultsWrapper>
            </div>
        </StyledAutocompleteWrapper>

    )
}

SearchAutocompleteView.defaultProps = {
    CustomNoResults: null,
    CustomResultsHeader: null,
    InputIcon: null,
    customNoResultsShowLogic: () => false,
    customResultsHeaderShowLogic: () => false,
    dropdownHeight: undefined,
    label: '',
    placeholder: '',
    tabIndex: undefined,
}


export default SearchAutocompleteView
